// extracted by mini-css-extract-plugin
export default {"container":"IssuesLoadingSkeleton-module__container__YaWxpGF"};